import { InjectionToken, Signal } from '@angular/core';
import { UserInfoResponse } from '../domain/profile.response';

export const USER_PROFILE = new InjectionToken<Signal<UserInfoResponse | null>>('USER_PROFILE');
